module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/neutralart-avatar-228cd174d1185f8403a23bdf550c1d60.jpg";